import { ROUTES } from "@/constants/routes.constants"

const LIGHT_ONLY_ROUTES: string[] = [ROUTES.start]

const isUnder = ({ pathname, route }: { pathname: string; route: string }) =>
    pathname === route || pathname.startsWith(`${route}/`)

export const forcedThemeOf = (pathname: string | null): "light" | undefined =>
    pathname !== null &&
    LIGHT_ONLY_ROUTES.some(route => isUnder({ pathname, route }))
        ? "light"
        : undefined
